import { createTheme } from '@mui/material/styles';
import { CommonThemeOptions } from './commonTheme';
import { type IThemeOptions } from './index';

export const Guitar2TabsOptions: IThemeOptions = {
  ...CommonThemeOptions,
  themeName: 'Guitar2Tabs',
  components: {
    ...CommonThemeOptions.components,
    MuiButton: {
      styleOverrides: {
        textPrimary: {
          color: '#F8B036',
          '&.Mui-disabled': {
            color: '#7c581b',
          },
        },
        outlinedPrimary: {
          color: '#F8B036',
          '&.Mui-disabled': {
            color: '#7c581b',
            border: '1px solid #7c581b',
          },
        },
        containedPrimary: {
          backgroundColor: '#F8B036',
          '&.Mui-disabled': {
            backgroundColor: '#7c581b',
            color: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        primary: {
          color: '#fff',
          backgroundColor: '#F8B036',
          background: '#F8B036', // transcribe button
          '&.Mui-disabled': {
            background: '#caced133',
            color: '#ffffff42',
          },
        },
      },
    },
  },
  palette: {
    ...CommonThemeOptions.palette,
    primary: {
      main: '#F8B036',
      light: '#FFDD00',
      dark: '#ff9a00',
      contrastText: '#000',
    },
  },
};

export const Guitar2TabsTheme = createTheme(Guitar2TabsOptions);
